'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _messageEdit = require('./message-edit.component');

var _messageEdit2 = _interopRequireDefault(_messageEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.dashboard.message-edit', []).component('messageEdit', _messageEdit2.default).value('EventEmitter', function (payload) {
  return { $event: payload };
}).name;


// WEBPACK FOOTER //
// ./components/app/dashboard/message-edit/message-edit.module.js